
(function ($) {
	jQuery.widget( "custom.autoselect", jQuery.ui.autocomplete, {
		_create: function(oo) {
			this._super();
			var that = this;
			if(this.element.val() !== '') {
				this.set();
			}
			this.element.on("blur", function(){
				if (!that.element.hasClass('autocomplete-selected')) {
					that.element.val('');
				}
			});
		},

		set: function(){
			var that = this;
			this.element.css("background-color", "#eee");
			this.element.attr("readonly", "true").autoselect({disabled: true});
			this.closeBtn = $("<span class='close-autoselect-btn'>&#10006;</span>").css({
				position: "relative",
				display: "inline-block",
				right: "24px",
				width: "20px",
				'margin-right': "-20px",
				cursor: "pointer"
			}).insertAfter(this.element).on("click mousedown touchstart", function(e){
				e.stopPropagation();
				e.preventDefault();
				that.clear();
			});
			this.element.addClass('autocomplete-selected');
		},
		
		_search: function (e) {
			if(e !== " ") {
				const values = e.split(' '); // /^[a-zA-Zа-яА-ЯёЁ0-9]/ первый символ — буква или цифры
				e = values.find(word => word && /^\S/.test(word.at(0)));  // по первому найденному слову, где первый символ - не пробел
				if (!e) { // если не подошло под поиск, то останавливаемся 
					return;
				}
			}
			this.pending++,
				this.element.addClass("ui-autocomplete-loading"),
				this.cancelSearch = !1,
				this.source({
					term: e
				}, this._response())
		},

		clear: function(){
			if (!this.element.hasClass('autocomplete-selected') || !this.closeBtn) {
				return;
			}
			this.element.removeClass('autocomplete-selected');
			if (this.options.clear) {
				this.options.clear(this);
			}
			this.element.css("background-color", "")
				.removeAttr("readonly")
				.autoselect({disabled: false})
				.val('');
			this.closeBtn.remove();
		},
		_destroy: function(e,ui){
			this.element.css("background-color", "")
				.removeAttr("readonly")
				.autoselect({disabled: false});
			if (this.closeBtn) {
				this.closeBtn.remove();
			}
		},
	});
})(jQuery);